import { Injectable } from '@angular/core';

import {
  Permission,
  RestaurantRole,
  ROLE_PERMISSIONS
} from './permissions';

export interface SelectedRestaurant {
  id: number;
  name?: string;
  role: RestaurantRole;
}

@Injectable({
  providedIn: 'root'
})
export class RestaurantContextService {

  private readonly storageKey =
    'selectedRestaurant';

  private selectedRestaurant:
    SelectedRestaurant | null = null;

  constructor() {
    this.restoreRestaurant();
  }

  setRestaurant(
    restaurant: SelectedRestaurant
  ): void {
    this.selectedRestaurant = {
      id: Number(restaurant.id),
      name: restaurant.name,
      role: restaurant.role
    };

    localStorage.setItem(
      this.storageKey,
      JSON.stringify(
        this.selectedRestaurant
      )
    );
  }

  getRestaurant():
    SelectedRestaurant | null {
    return this.selectedRestaurant;
  }

  getRestaurantId(): number | null {
    return this.selectedRestaurant?.id ??
      null;
  }

  getRole(): RestaurantRole | null {
    return this.selectedRestaurant?.role ??
      null;
  }

  hasPermission(
    permission: Permission
  ): boolean {
    const role = this.getRole();

    if (!role) {
      return false;
    }

    return ROLE_PERMISSIONS[
      role
    ].includes(permission);
  }

  clear(): void {
    this.selectedRestaurant = null;

    localStorage.removeItem(
      this.storageKey
    );
  }

  private restoreRestaurant(): void {
    const storedRestaurant =
      localStorage.getItem(
        this.storageKey
      );

    if (!storedRestaurant) {
      return;
    }

    try {
      const restaurant =
        JSON.parse(
          storedRestaurant
        ) as SelectedRestaurant;

      if (
        restaurant?.id &&
        restaurant?.role
      ) {
        this.selectedRestaurant =
          restaurant;
      }
    } catch {
      localStorage.removeItem(
        this.storageKey
      );
    }
  }
}